<div style="margin-left: 30px">
  <file-picker
    [offlineUpload]="true"
    [emitOfflineAssets]="true"
    (assetsAdded)="onAssetsAdded($event)"
  >
  </file-picker>
</div>

<!-- Saved assets -->

<ng-container *ngIf="sign.id && sign.examples != null">
  <div
    *ngFor="let item of sign.examples; index as i"
    class="align-middle max-picker-width"
    [ngClass]="getAssetClass(item, i == 0)"
    matTooltip="{{ item?.asset?.name }}"
  >
    <div class="d-flex box click-link max-picker-width">
      <a
        download="{{ item.asset.name }}"
        [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
        style="margin-right: 7px"
        class="d-flex box"
      >
        <div class="filename">{{ shortenName(item?.asset?.name) }}</div>

        <a>
          <mat-icon aria-hidden="false" aria-label="remove">
            cloud_download
          </mat-icon>
        </a>
      </a>

      <a>
        <mat-icon
          style="cursor: pointer"
          aria-hidden="false"
          aria-label="remove"
          (click)="removeOnlineFile(item, i)"
        >
          delete
        </mat-icon>
      </a>
    </div>

    <div>
      <a
        class="click-link"
        [href]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
        *ngIf="isImage(item.asset)"
        data-lightbox="product"
      >
        <img
          class="max-picker-width max-picker-height"
          *ngIf="isImage(item.asset)"
          [src]="item.asset.uuid | assetSource : item.asset.localSafeUrl"
        />
      </a>
    </div>
  </div>
</ng-container>

<!-- Offline assets -->

<div
  *ngFor="let item of sign.offlineExamples; index as i"
  class="align-middle max-picker-width loadedImg asset-container"
  matTooltip="{{ item?.name }}"
>
  <div class="d-flex box click-link max-picker-width">
    <a
      download="{{ item.name }}"
      [href]="item.uuid | assetSource : item.localSafeUrl"
      style="margin-right: 7px"
      class="d-flex box"
    >
      <div class="filename">{{ shortenName(item?.name) }}</div>

      <a>
        <mat-icon aria-hidden="false" aria-label="remove">
          cloud_download
        </mat-icon>
      </a>
    </a>

    <mat-icon
      style="cursor: pointer"
      aria-hidden="false"
      aria-label="remove"
      (click)="removeOfflineFile(item, i)"
    >
      delete
    </mat-icon>
  </div>

  <div>
    <a
      class="click-link"
      [href]="item.uuid | assetSource : item.localSafeUrl"
      *ngIf="isImage(item)"
      data-lightbox="product"
    >
      <img
        class="max-picker-width max-picker-height"
        *ngIf="isImage(item)"
        [src]="item.uuid | assetSource : item.localSafeUrl"
      />
    </a>
  </div>
</div>
